import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Select2"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M9 4.5H6V1.5H4.5V4.5H1.5V6H4.5V9H6V6H9V4.5zM22.5 7.5V3H18V4.5H12V6H18V7.5H19.5V18H18V19.5H7.5V18H6V12H4.5V18H3V22.5H7.5V21H18V22.5H22.5V18H21V7.5H22.5zM6 21H4.5V19.5H6V21zM21 21H19.5V19.5H21V21zM19.5 4.5H21V6H19.5V4.5z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Select2.vue"]]);
